import { createSlice } from "@reduxjs/toolkit";
import { BuscarLancamentoConsignatarioModel } from "../../../models/lancamentoConsignatario/buscarLancamentoConsignatarioModel";
import { LancamentoConsignatarioModel } from "../../../models/lancamentoConsignatario/lancamentoConsignatarioModel";
import { resetAll } from "../../actions/actions";
import { listarLancamentoConsignatario } from "../../../services/lancamentoConsignatarioService";
import dayjs from "dayjs";

dayjs.locale("pt-br");

export interface LancamentoConsignatarioState {
  //buscar lancamento consignatario
  loading: boolean;
  busca: BuscarLancamentoConsignatarioModel;
  list: LancamentoConsignatarioModel[];
  entity: LancamentoConsignatarioModel;
  //internal
  isData: boolean;
  modalCadastrar: boolean;
  modalDeletar: boolean;
  modalVisualizarReciboConsignatario: boolean;
}

const initialState: LancamentoConsignatarioState = {
  //buscar lancamento consignatario
  loading: false,
  busca: {
    idConsignatario: null,
    dataInicio: dayjs().startOf("month").toDate(),
    dataFim: dayjs().toDate(),
  } as BuscarLancamentoConsignatarioModel,
  list: [],
  entity: {} as LancamentoConsignatarioModel,
  //internal
  isData: false,
  modalCadastrar: false,
  modalDeletar: false,
  modalVisualizarReciboConsignatario: false,
};

export const lancamentoConsignatarioSlice = createSlice({
  name: "lancamentoConsignatario",
  initialState,
  reducers: {
    //buscar lancamento consignatario
    setBuscaLancamentoConsignatario: (state, action) => {
      state.busca = action.payload;
    },
    setEntityLancamentoConsignatario: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarLancamentoConsignatario: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarLancamentoConsignatario: (state, action) => {
      state.modalDeletar = action.payload;
    },
    setModalVisualizarReciboConsignatario: (state, action) => {
      state.modalVisualizarReciboConsignatario = action.payload;
    },
    setIsDataLancamentoConsignatario: (state, action) => {
      state.isData = action.payload;
    },
    setListLancamentoConsignatario: (state, action) => {
      state.list = action.payload;
    },
    resetLancamentoConsignatario: () => initialState,
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar lancamento consignatario
    builder.addCase(listarLancamentoConsignatario.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarLancamentoConsignatario.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(listarLancamentoConsignatario.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar lancamento consignatario
  setBuscaLancamentoConsignatario,
  setEntityLancamentoConsignatario,
  //internal
  setModalCadastrarLancamentoConsignatario,
  setModalDeletarLancamentoConsignatario,
  setModalVisualizarReciboConsignatario,
  setIsDataLancamentoConsignatario,
  setListLancamentoConsignatario,
  resetLancamentoConsignatario,
} = lancamentoConsignatarioSlice.actions;

export default lancamentoConsignatarioSlice.reducer;
